import { Header } from '../../components/Shared/NavBar/Header.jsx';
import { TracingSolicitud } from '../../components/Tracing/TracingSolicitud.jsx';
export const TracingViewSolicitud = () => {
  return (
    <>
      <Header />
      <TracingSolicitud/>
    </>
  );
};